import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	radio: {
		color: colors.purple[800],
		"&.Mui-checked": {
			color: colors.purple[800]
		}
	},
	container: {
		border: "1px solid red",
		padding: 16,
		borderColor: colors.gray[600],
		borderRadius: 6
	}
})

export default useStyles
